module.exports = __webpack_public_path__ + "static/media/main.eebb8a88.png";